import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.636 1.84a6.667 6.667 0 1 1 5.103 12.32A6.667 6.667 0 0 1 5.636 1.84M2.902 8.716a5.33 5.33 0 0 0 1.073 2.555l1.483-1.483a5.33 5.33 0 0 0-2.556-1.072m3.505.123A6.67 6.67 0 0 0 2.89 7.371 5.33 5.33 0 0 1 3.974 4.73L7.244 8zM6.4 10.73l-1.484 1.483a5.33 5.33 0 0 0 2.556 1.072A5.33 5.33 0 0 0 6.4 10.73m2.416 2.566a6.67 6.67 0 0 0-1.468-3.515l.839-.838 3.27 3.27a5.34 5.34 0 0 1-2.641 1.083M6.147 3.073a5.3 5.3 0 0 1 1.411-.369 6.67 6.67 0 0 0 1.468 3.515l-.838.838-3.27-3.27a5.3 5.3 0 0 1 1.229-.714m2.755-.358A5.33 5.33 0 0 0 9.975 5.27l1.483-1.483a5.33 5.33 0 0 0-2.556-1.072M9.13 8l.839-.838a6.67 6.67 0 0 0 3.515 1.467A5.33 5.33 0 0 1 12.4 11.27zm1.787-1.787a5.33 5.33 0 0 0 2.556 1.072A5.34 5.34 0 0 0 12.4 4.73z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })